/**
 * ExecPro360 - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
import LegalLayout from "../components/LegalLayout";
import {
  PUBLISHER_NAME, PUBLISHER_LEGAL_FORM, PUBLISHER_CAPITAL, PUBLISHER_SIREN, PUBLISHER_RCS,
  PUBLISHER_ADDRESS, PUBLISHER_PRESIDENT, PUBLISHER_PHONE, CONTACT_EMAIL, HOST,
} from "../config/legal";

export default function MentionsLegales() {
  return (
    <LegalLayout current="mentions" title="Mentions légales" updated="Dernière mise à jour : octobre 2026 · ExecPro360">
      <h2>Éditeur du site</h2>
      <p>
        Le site est édité par :<br />
        {PUBLISHER_NAME}, {PUBLISHER_LEGAL_FORM} au capital de {PUBLISHER_CAPITAL}<br />
        SIREN {PUBLISHER_SIREN} — {PUBLISHER_RCS}<br />
        Siège social : {PUBLISHER_ADDRESS}<br />
        {PUBLISHER_PHONE && <>Téléphone : {PUBLISHER_PHONE}<br /></>}
        Email : <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>

      <h2>Directrice de la publication</h2>
      <p>{PUBLISHER_PRESIDENT}, présidente de {PUBLISHER_NAME}</p>

      <h2>Hébergement</h2>
      <p>
        Le site est hébergé par :<br />
        {HOST.name}<br />
        {HOST.address}<br />
        Téléphone : {HOST.phone}<br />
        Site web : <a href={HOST.website} target="_blank" rel="noreferrer">{HOST.websiteLabel}</a>
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu du site (textes, structure, code, logo) est protégé par le droit
        d'auteur. Toute reproduction sans autorisation est interdite.
      </p>

      <h2>Contact</h2>
      <p>
        Pour toute question relative à ces mentions légales :{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>
    </LegalLayout>
  );
}
